import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
// i18n must be imported BEFORE App so the i18next instance is ready by
// the time any component calls useTranslation(). The import has the side
// effect of initialising i18next with detection + resources.
import './i18n'
import App from './App.tsx'
import { ConfirmProvider } from './components/ConfirmDialog.tsx'
import { ErrorBoundary } from './components/ErrorBoundary.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <ConfirmProvider>
        <App />
      </ConfirmProvider>
    </ErrorBoundary>
  </StrictMode>,
)
